import React from 'react'
import { addNewTag, assignNewTag } from 'client/utils/api-routes-orders'
import { OrdersContext } from 'contexts/OrdersContext'
import {
  DcFlexBox,
  DcInputTag,
  PixelFactoryContext,
  PixelText,
} from 'pixel-base'
import { IPixelFactory, OrderDetail } from '../../../../../decl.d'

interface IProps {
  details: OrderDetail
  detailID: number
  setDetails: (details: OrderDetail) => void
  newOrder: boolean
  newOrderData: OrderDetail
  setNewOrderData: (newOrderData: OrderDetail) => void
  isItInvoice: boolean
}
const Tags = (props: IProps) => {
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [incomingTags, setIncomingTags] = React.useState([])
  const { details, setDetails, detailID } = props
  const [tags, setTags] = React.useState([])
  const { state } = React.useContext(OrdersContext)
  const [updateTag, setUpdateTag] = React.useState({
    enable: true,
    tag_name: '',
  })

  const handleAssignTag = () => {
    showPageLoader()
    assignNewTag(detailID, updateTag).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        setDetails({
          ...details,
          order_tags: res.response.data,
        })
      }
      if (res.response.error) {
        showFailure(res.response.error)
      }
    })
  }
  React.useEffect(() => {
    if (details?.order_tags?.length > 0) {
      setIncomingTags(
        details?.order_tags?.map((tag) => {
          return {
            ...tag,
            label: tag.tag_name,
            value: tag.tag_name,
          }
        }),
      )
    }
  }, [details?.order_tags])

  React.useEffect(() => {
    const newTags: any = state?.orderTags?.map((tag: any) => {
      return {
        ...tag,
        label: tag.tag_name,
        value: tag.tag_name,
        disabled: false,
        clickHandler: () => {
          setUpdateTag({
            enable: true,
            tag_name: tag.tag_name,
          })
        },
      }
    })
    if (tags.length === 0) setTags(newTags)
  }, [state.newOrderTags])
  React.useEffect(() => {
    if (updateTag.tag_name !== '') {
      handleAssignTag()
    }
  }, [updateTag])
  const handleAddNewTag = (action, data) => {
    if (action === 'add') {
      showPageLoader()
      addNewTag(detailID, data).subscribe((res: any) => {
        hidePageLoader()
        if (res.response.data) {
          showSuccess('Tag added successfully')

          setIncomingTags(
            res.response.data?.map((tag) => {
              return {
                ...tag,
                label: tag.tag_name,
                value: tag.tag_name,
              }
            }),
          )
        } else {
          showFailure(res.response.error)
        }
      })
    }
  }
  return (
    <DcFlexBox
      flexDirection="column"
      alignContent="center"
      style={{ borderBottom: '1px solid #e6e6e6' }}
      padding="10px"
    >
      <DcFlexBox alignItem="center">
        <PixelText>Tags</PixelText>
      </DcFlexBox>
      <DcFlexBox flexDirection="column">
        <DcInputTag
          // inputLabel={'Assign Tags'}
          isAllClearable={false}
          noDataText={'No tags found'}
          placeholder={'Tags'}
          tags={incomingTags}
          options={tags}
          handleTagAdd={(tag) => {
            handleAddNewTag('add', {
              enable: true,
              tag_name: tag.value,
            })
          }}
          handleTagDelete={(tag) => {
            setUpdateTag({
              enable: false,
              tag_name: tag.value,
            })
          }}
        />
      </DcFlexBox>
    </DcFlexBox>
  )
}

export default Tags
